globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { useTranslation } from 'next-i18next';
import { Title } from '../../';
import { LongParagraph } from '../../design-system/long-paragraph';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var DescriptionBlock = function DescriptionBlock(_ref) {
  var subTitle = _ref.subTitle,
      jobContractDesc = _ref.jobContractDesc;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(DescriptionWrapper, {
    children: [/*#__PURE__*/_jsx(Title, {
      content: t('description'),
      variant: "h4-xlarge",
      textColor: "black",
      fontWeight: "semibold",
      icon: "BookOpenIcon"
    }), /*#__PURE__*/_jsx(LongParagraph, {
      subTitle: subTitle,
      content: jobContractDesc,
      isHtml: true,
      maxLength: 450,
      title: t('description'),
      headerIcon: "BookOpenIcon",
      btnTitle: t('keep_on_reading')
    })]
  });
};
export default DescriptionBlock; // --> styled components

var DescriptionWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "job-description-block__DescriptionWrapper",
  componentId: "sc-cbm2zr-0"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "gap": "1rem",
  "borderRadius": "1rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
  "padding": "2rem"
});